import React from 'react';

import {
	ButtonProps,
	Button,
} from '@components';

import {
	useClassNames,
} from '@common';

import './IconButton.scss';

interface IconButtonProps extends ButtonProps {
	icon: JSX.Element,
	iconSize?: string,
}

const IconButton = React.forwardRef<HTMLDivElement, IconButtonProps>((props: IconButtonProps, ref): JSX.Element => {
	const {
		icon,
		className,
		theme = 'ghost',
		iconSize = '40px',
		...buttonProps
	} = props;

	const
		classes = useClassNames('icon-button', className),
		iconStyles = {
			fontSize: iconSize,
		};

	return (
		<Button className={classes} theme={theme} ref={ref} {...buttonProps}>
			<span className="icon-button__icon" style={iconStyles}>
				{icon}
			</span>
			{props.children &&
				(<span className="icon-button__text">
					{props.children}
				</span>)
			}
		</Button>
	);
});

const MemoisedIconButton = React.memo(IconButton);

export {MemoisedIconButton as IconButton};